import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const NewBadgeStyles = {
  base: css`
    align-items: center;
    content: 'new';
    display: flex;
    font-size: ${theme.fontSize(8)};
    font-weight: ${theme.font.weight.semibold};
    justify-content: center;
    padding: ${theme.spacing(0.4, 0.6, 0.25)};
    text-transform: uppercase;
    border-radius: ${theme.borderRadius.small};
    border: 1px solid ${theme.colors.primary50};
  `,
  light: css`
    background-color: ${theme.colors.primary10};
    color: ${theme.colors.primary70};
  `,
  dark: css`
    background-color: ${theme.colors.primary70};
    color: ${theme.colors.white};
  `,
};
